import React from 'react';
import { SectionTitle, Paragraph, CTAButton, Divider } from './Shared';
export function SectionPricingAndOutro() {
  return <section data-id="element-117">
      <div className="bg-gray-50 p-8 rounded-lg border border-gray-200 mb-12" data-id="element-118">
        <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-119">
          Just To Recap, Here's Everything You'll Get…
        </h3>

        <ul className="space-y-6 text-gray-800" data-id="element-120">
          <li className="flex items-start" data-id="element-121">
            <span className="text-brand-green font-bold mr-2" data-id="element-122">✓</span>
            <span data-id="element-123">
              <strong data-id="element-124">The ClearGuard Pro 90-Day Reset Kit</strong> — Your full
              3-bottle clinical supply of the only formula combining
              pharmaceutical-grade microcrystalline hydroxyapatite, three
              shelf-stable clinical probiotic strains, and the two most studied
              biofilm disruptors in dental science. The exact same protocol used
              in my father and brother's office — now in your hands. (Value:
              $207)
            </span>
          </li>
          <li className="flex items-start" data-id="element-125">
            <span className="text-brand-green font-bold mr-2" data-id="element-126">✓</span>
            <span data-id="element-127">
              <strong data-id="element-128">Bonus #1: The "VIP Concierge" Dental Hotline</strong> —
              Direct 24/7 digital access to two real, practicing dentists who
              pioneered this exact protocol. No waiting rooms, no 5-minute
              appointments, no judgment. Just real answers from the people who
              have seen these results firsthand. (Value: $297)
            </span>
          </li>
          <li className="flex items-start" data-id="element-129">
            <span className="text-brand-green font-bold mr-2" data-id="element-130">✓</span>
            <span data-id="element-131">
              <strong data-id="element-132">Bonus #2: The "Microbial Fingerprint" Diet Guide</strong>{' '}
              — The 5 common foods secretly feeding the bad bacteria hiding in
              your micro-cracks, plus 3 prebiotic "super-fuels" that amplify the
              results of your LS97 and LC86 strains. Includes the "Cheese
              Finish" trick that instantly raises your oral pH after every meal.
              (Value: $39)
            </span>
          </li>
          <li className="flex items-start" data-id="element-133">
            <span className="text-brand-green font-bold mr-2" data-id="element-134">✓</span>
            <span data-id="element-135">
              <strong data-id="element-136">Bonus #3: The "Emergency Social Rinse"</strong> — The
              3-ingredient kitchen rinse for instant fresh-breath and confidence
              on the days you need it most. This "emergency" soak unsticks
              bacteria from micro-cracks and creates an alkaline environment
              that lasts for hours, without harming a single bacteria in your
              mouth. (Value: $29)
            </span>
          </li>
          <li className="flex items-start" data-id="element-137">
            <span className="text-brand-green font-bold mr-2" data-id="element-138">✓</span>
            <span data-id="element-139">
              <strong data-id="element-140">Bonus #4: The "Night-Guard" Hack</strong> — The 10-second
              jaw reset that stops 250lb sleep-grinding, ensuring your newly-repaired teeth don't snap
              overnight. Includes the simple tongue positioning trick for
              relaxing your jaw before bed. (Value: $29)
            </span>
          </li>
        </ul>

        <img src="https://cdn.magicpatterns.com/uploads/dZzAyaQUVqoFgrffMpta1f/hf_20260422_020817_ef915454-1d09-4748-9e8b-d41e4e1ddcab_(1).png" alt="ClearGuard Pro 90-Day Reset Kit with bonuses - bottles, diet guide, night-guard hack, emergency rinse, and VIP dental concierge" className="w-full my-8" data-id="element-141" />

        <p className="text-xl font-bold text-center mt-8 text-gray-900" data-id="element-142">
          That's a total value of $601!
        </p>
        <p className="text-lg text-center mt-2 text-gray-800" data-id="element-143">
          But with today's special offer, you'll NOT pay anywhere near that.
        </p>
        <p className="text-lg text-center mt-2 text-gray-800" data-id="element-144">
          Here's what I propose…
        </p>
      </div>

      <SectionTitle data-id="element-145">Take a Full 3-Months To Try It – No Pressure</SectionTitle>

      <Paragraph data-id="element-146">
        According to the American Dental Association, the average American
        spends between $500 - $1,500 on dental care annually, and that number is
        only climbing…
      </Paragraph>

      <Paragraph data-id="element-147">
        To put that into perspective, that's about $51,000 over a lifetime.
      </Paragraph>

      <Paragraph data-id="element-148">
        And not to mention, most of that money is spent on 'reactive' dentistry,
        or the 'drilling and filling' model the dental industry uses to profit
        from suffering, rather than solving it.
      </Paragraph>

      <Paragraph data-id="element-149">
        It's no wonder 92% of adults delay care because of these costs…
      </Paragraph>

      <Paragraph data-id="element-150">
        Because of this, we refuse to price ClearGuard Pro out of reach for the
        people who need it most.
      </Paragraph>

      <Paragraph data-id="element-151">
        In fact, we want to make it as easy and hassle-free as possible for you
        to try this for yourself.
      </Paragraph>

      <Paragraph data-id="element-152">
        So we priced the full 90-day reset kit at a level that would barely
        cover our costs, since that's the only version that feels right to us.
      </Paragraph>

      <Paragraph data-id="element-153">
        Instead of paying the full value of $601… You'll only pay a tiny
        fraction… $98!
      </Paragraph>

      <Paragraph data-id="element-154">
        And it means that for just $31 a month, or $1.09 a day, you can perform
        a complete biological and structural reset on your teeth.
      </Paragraph>

      <Paragraph data-id="element-155">
        On top of that, you'll get everything else I promised today… including
        24/7 access to two dentists for any unanswered questions you may have…
      </Paragraph>

      <Paragraph data-id="element-156">
        Along with decades worth of insider teeth knowledge that are tactical
        upgrades to your daily life.
      </Paragraph>

      <div className="border-2 border-dashed border-gray-300 p-8 bg-yellow-50/50 my-12" data-id="element-157">
        <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-158">
          I've also prepared a special "risk nothing, keep everything"
          guarantee.
        </h3>

        <Paragraph data-id="element-159">
          When you lock in your Full 90-Day Reset Kit today, we'll give you a
          full 3 months to test out the protocol – at no risk to you.
        </Paragraph>

        <Paragraph data-id="element-160">
          During those 3 months, we will personally check in with you once a
          week through email to ensure everything is going smoothly.
        </Paragraph>

        <Paragraph data-id="element-161">
          If, during those 90 days, you find you're not satisfied with your
          healthy gums, fresh breath, and newfound smile…
        </Paragraph>

        <Paragraph data-id="element-162">
          You can simply call or email our customer service team, and we'll give
          you a full refund, no questions asked.
        </Paragraph>

        <Paragraph data-id="element-163">
          And we'll let you keep ALL three bonus gifts you receive - at no
          charge.
        </Paragraph>

        <ul className="list-disc pl-6 mb-6 text-gray-800 space-y-2" data-id="element-164">
          <li data-id="element-165">
            You can keep the "Microbial Fingerprint" Diet Guide, which includes
            the little-known "Cheese Finish" trick that instantly raises your
            oral pH level after every meal.
          </li>
          <li data-id="element-166">
            You can keep the "Night-Guard" Hack, which teaches you the simple
            10-second jaw reset to ensure your newly-repaired teeth don't snap
            overnight
          </li>
          <li data-id="element-167">
            You can keep the "Emergency Social Rinse", which reveals the
            2-ingredient kitchen rinse for instant confidence on the days you
            need it most.
          </li>
        </ul>

        <Paragraph data-id="element-168">
          You can keep everything… which means there's no risk to you at all.
        </Paragraph>

        <Paragraph data-id="element-169">
          It's our way of saying thank you for giving ClearGuard Pro a try.
        </Paragraph>
      </div>

      <SectionTitle data-id="element-170">
        But Before You Go, I Want To Leave You With Something To Think About
      </SectionTitle>

      <Paragraph data-id="element-171">
        As I showed you today, the very "wrinkles" on teeth which dentists often
        pass up as 'just-aging' is the missing-link of dental health, according
        to the Journal of Endodontics.
      </Paragraph>

      <Paragraph data-id="element-172">
        And while most people will still be scrubbing for years, not knowing the
        very bacteria causing their problems are in a place no amount of hygiene
        can reach…
      </Paragraph>

      <Paragraph data-id="element-173">
        You, on the other hand, are one of the first to learn about this
        cutting-edge discovery, before it becomes widely known, and that's if it
        ever even does.
      </Paragraph>

      <Paragraph data-id="element-174">
        More importantly, you know how to finally end the cycle of frustration,
        without stepping foot in a dentist's office.
      </Paragraph>

      <Paragraph data-id="element-175">
        But instead, by simply dissolving one lozenge in your mouth, every
        single day, for 90 days.
      </Paragraph>

      <Paragraph data-id="element-176">
        One that addresses the problem both structurally, and biologically,
        making it the first of its kind to do so.
      </Paragraph>

      <Paragraph data-id="element-177">
        Now while I don't know how long this page will stay up, what I do know
        is this…
      </Paragraph>

      <Paragraph data-id="element-178">
        The micro-crack reality you read about today isn't going away.
      </Paragraph>

      <Paragraph data-id="element-179">
        In fact, with every meal you eat, every cup of coffee you drink, and
        every night you grind your teeth in your sleep, which is surprisingly
        more common than you think…
      </Paragraph>

      <Paragraph data-id="element-180">
        The micro-cracks get deeper, and the bacteria inside them get more
        entrenched.
      </Paragraph>

      <Paragraph data-id="element-181">
        Simply put, the window between "this is fixable at home for $1.09 a day"
        and "you need a $5,000 implant" is closing quietly.
      </Paragraph>

      <Paragraph data-id="element-182">
        When you think about it like that, you simply have to respond to this
        offer right away, and there's really no reason why you shouldn't…
      </Paragraph>

      <Paragraph data-id="element-183">
        This is why I urge you to not waste any time… and act now, while we
        still have units left.
      </Paragraph>

      <Paragraph data-id="element-184">
        Because once we're out, it may take one, two, or even three months in
        order for us to source all the ingredients and create a new batch.
      </Paragraph>

      <Paragraph data-id="element-185">
        Go ahead and click the button below to claim your Full 90-Day Reset Kit,
        completely risk-free…
      </Paragraph>

      <div className="my-12" data-id="element-186">
        <h3 className="text-2xl font-bold text-center mb-6 text-gray-900" data-id="element-187">
          Click the Button Below To Get Started On Your Path To a Newfound Smile
        </h3>
        <CTAButton data-id="element-188">Claim Your 90-Day Reset Kit</CTAButton>
      </div>

      <Paragraph data-id="element-189">
        I sincerely hope we see you on the other side today.
      </Paragraph>

      <Paragraph data-id="element-190">Because similarly to how…</Paragraph>

      <Paragraph data-id="element-191">
        Colleen, who went for a checkup, and shocked her periodontist…
      </Paragraph>

      <Paragraph data-id="element-192">
        Carolyn, who saved $900 because she didn't need a deep cleaning anymore…
      </Paragraph>

      <Paragraph data-id="element-193">
        And Barbara, who thought she would be doomed with cavities forever…
      </Paragraph>

      <Paragraph data-id="element-194">We want YOU to be our next success story.</Paragraph>

      <Paragraph data-id="element-195">
        Because the only difference between someone who finally ends the cycle,
        and the person who stays stuck in it?
      </Paragraph>

      <Paragraph data-id="element-196">
        It's the decision made on a page exactly like this one.
      </Paragraph>

      <Paragraph data-id="element-197">
        We've given you our very best price offer… and a "risk nothing and keep
        everything" guarantee.
      </Paragraph>

      <Paragraph data-id="element-198">
        That's zero downside… for what could be your only chance to stop being
        someone who hides their mouth, and instead, become someone who smiles
        freely, forever.
      </Paragraph>

      <Paragraph data-id="element-199">To get started, simply click on the button below.</Paragraph>

      <Paragraph data-id="element-200">
        It will take you to a secure checkout page, where you can review
        everything one last time before you claim your Full 90-Day Reset Kit.
      </Paragraph>

      <Paragraph data-id="element-201">
        Thanks for reading… and we look forward to welcoming you to ClearGuard
        Nutrition in the next few minutes.
      </Paragraph>

      <div className="my-12 pb-12" data-id="element-202">
        <CTAButton data-id="element-203">Claim Your 90-Day Reset Kit</CTAButton>
      </div>

      <div className="border-t border-gray-200 pt-10 pb-8 mt-8" data-id="element-204">
        <h4 className="text-center text-gray-400 font-bold text-sm uppercase tracking-[0.25em] mb-6" data-id="element-205">
          Scientific References
        </h4>
        <ul className="space-y-1 text-center text-gray-400 text-sm" data-id="element-206">
          <li data-id="element-207">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC9955010/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-208">
              pmc.ncbi.nlm.nih.gov/articles/PMC9955010/
            </a>
          </li>
          <li data-id="element-209">
            <a href="https://clinicaltrials.gov/study/NCT02444182" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-210">
              clinicaltrials.gov/study/NCT02444182
            </a>
          </li>
          <li data-id="element-211">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC9131035/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-212">
              pmc.ncbi.nlm.nih.gov/articles/PMC9131035/
            </a>
          </li>
          <li data-id="element-213">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC4232036/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-214">
              pmc.ncbi.nlm.nih.gov/articles/PMC4232036/
            </a>
          </li>
          <li data-id="element-215">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC12466288/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-216">
              pmc.ncbi.nlm.nih.gov/articles/PMC12466288/
            </a>
          </li>
          <li data-id="element-217">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC6926775/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-218">
              pmc.ncbi.nlm.nih.gov/articles/PMC6926775/
            </a>
          </li>
          <li data-id="element-219">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC4127827/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-220">
              pmc.ncbi.nlm.nih.gov/articles/PMC4127827/
            </a>
          </li>
          <li data-id="element-221">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC12705589/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-222">
              pmc.ncbi.nlm.nih.gov/articles/PMC12705589/
            </a>
          </li>
          <li data-id="element-223">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC9668099/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-224">
              pmc.ncbi.nlm.nih.gov/articles/PMC9668099/
            </a>
          </li>
          <li data-id="element-225">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC10187049/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-226">
              pmc.ncbi.nlm.nih.gov/articles/PMC10187049/
            </a>
          </li>
          <li data-id="element-227">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC10421449/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-228">
              pmc.ncbi.nlm.nih.gov/articles/PMC10421449/
            </a>
          </li>
          <li data-id="element-229">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC5851198/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-230">
              pmc.ncbi.nlm.nih.gov/articles/PMC5851198/
            </a>
          </li>
          <li data-id="element-231">
            <a href="https://pmc.ncbi.nlm.nih.gov/articles/PMC5824418/" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600 transition-colors" data-id="element-232">
              pmc.ncbi.nlm.nih.gov/articles/PMC5824418/
            </a>
          </li>
        </ul>
      </div>
    </section>;
}